export enum VehicleStatusCode {
  
  // ----------------------------------------------------------------------------
  // Reserved status codes: [E0-00 through FF-FF]
  // Groups:
  //      0xF0..  - Generic
  //      0xF1..  - Motion
  //      0xF2..  - Geofence
  //      0xF4..  - Digital input/output
  //      0xF6..  - Sensor input
  //      0xF7..  - Temperature input
  //      0xF9..  - OBC/J1708
  //      0xFD..  - Device status
  // ----------------------------------------------------------------------------

  STATUS_IGNORE               = -1,

  // ----------------------------------------------------------------------------
  // Reserved: 0x0000 to 0x0FFF
  // No status code: 0x0000

  STATUS_NONE                 = 0x0000,

  // ----------------------------------------------------------------------------
  // Available: 0x1000 to 0xCFFF
  STATUS_1000                 = 0x1000,   //  4096
  // ...
  STATUS_CFFF                 = 0xCFFF,   // 53247

  // ----------------------------------------------------------------------------
  // Reserved: 0xD000 to 0xEFFF

  // --- DCS custom event mapped codes (CalAmp/Enfora/etc)
  STATUS_E000                 = 0xE000,
  // ...
  STATUS_E0FF                 = 0xE0FF,

  // --- Start of standard status codes
  STATUS_E100                 = 0xE100,

  // -- Garmin GFMI interface [0xE100 - 0xE1FF]
  STATUS_GFMI_CMD_03          = 0xE103,   // 57603 send non-ack message
  STATUS_GFMI_CMD_04          = 0xE104,   // 57604 send ack message
  STATUS_GFMI_CMD_05          = 0xE105,   // 57605 send answerable message
  STATUS_GFMI_CMD_06          = 0xE106,   // 57606 send stop location
  STATUS_GFMI_CMD_08          = 0xE108,   // 57608 request stop ETA
  STATUS_GFMI_CMD_09          = 0xE109,   // 57609 set auto arrival criteria
  // -- Garmin link
  STATUS_GFMI_LINK_OFF        = 0xE110,   // 57616 GFMI Link lost
  STATUS_GFMI_LINK_ON         = 0xE111,   // 57617 GFMI Link established
  STATUS_GFMI_HEARTBEAT       = 0xE115,   // 57621 GFMI Link Heartbeat
  // -- Garmin ACK
  STATUS_GFMI_ACK             = 0xE1A0,   // 57760 received ACK
  STATUS_GFMI_MESSAGE         = 0xE1B1,   // 57777 received message
  STATUS_GFMI_MESSAGE_ACK     = 0xE1B2,   // 57778 received message ACK
  // -- Garmin Stop Status change
  STATUS_GFMI_STOP_STATUS_1   = 0xE1C1,   // 57793 stop status
  STATUS_GFMI_STOP_STATUS_2   = 0xE1C2,   // 57794 stop status
  STATUS_GFMI_STOP_STATUS_3   = 0xE1C3,   // 57795 stop status
  STATUS_GFMI_STOP_STATUS_4   = 0xE1C4,   // 57796 stop status
  // -- Garmin ETA
  STATUS_GFMI_ETA             = 0xE1C9,   // 57801 ETA
  // -- Garmin Driver
  STATUS_GFMI_DRIVER_ID       = 0xE1D1,   // 57809 driver id
  STATUS_GFMI_DRIVER_STATUS   = 0xE1D3,   // 57811 driver status

  // ----------------------------------------------------------------------------
  // Generic codes: 0xF000 to 0xF0FF

  STATUS_INITIALIZED          = 0xF010,   // 61456
  // Description:
  //      General Status/Location information (event generated by some
  //      initialization function performed by the device).

  STATUS_LOCATION             = 0xF020,   // 61472
  STATUS_LOCATION_1           = 0xF021,   // 61473
  STATUS_LOCATION_2           = 0xF022,   // 61474
  STATUS_LOCATION_3           = 0xF023,   // 61475
  STATUS_LOCATION_4           = 0xF024,   // 61476
  // Description:
  //      General Status/Location event, typically based on a time-interval.  
  //      This status code indicates no more than just the location of the 
  //      device at a particular time.

  STATUS_LAST_LOCATION        = 0xF025,   // 61477
  // Description:
  //      General Status/Location event.  This status code indicates
  //      the last known location of the device (GPS may not be current)

  STATUS_CELL_LOCATION        = 0xF029,   // 61481
  // Description:
  //      Indicates a location generated by analyzing the MCC/MNC/LAC/CID
  //      information retrieve from the cell tower.

  STATUS_DISTANCE             = 0xF02C,   // 61484
  STATUS_DISTANCE_1           = 0xF02D,   // 61485
  STATUS_DISTANCE_2           = 0xF02E,   // 61486
  // Description:
  //      General Status/Location event, typically based on a distance-interval.  
  //      This status code indicates no more than just the location of the 
  //      device at a particular distance-interval.

  STATUS_WAYMARK_0            = 0xF030,   // 61488
  STATUS_WAYMARK_1            = 0xF031,   // 61489
  STATUS_WAYMARK_2            = 0xF032,   // 61490
  STATUS_WAYMARK_3            = 0xF033,   // 61491
  STATUS_WAYMARK_4            = 0xF034,   // 61492
  STATUS_WAYMARK_5            = 0xF035,   // 61493
  STATUS_WAYMARK_6            = 0xF036,   // 61494
  STATUS_WAYMARK_7            = 0xF037,   // 61495
  STATUS_WAYMARK_8            = 0xF038,   // 61496
  STATUS_WAYMARK_9            = 0xF039,   // 61497
  // Description:
  //      General Status/Location information (event generated by manual user
  //      intervention at the device. ie. By pressing a 'Waymark' button).

  STATUS_QUERY                = 0xF040,   // 61504
  // Description:
  //      General Status/Location information (event generated by 'query'
  //      from the server).

  STATUS_NOTIFY               = 0xF044,   // 61508
  // Description:
  //      General notification triggered by device operator

  STATUS_LOG                  = 0xF049,   // 61513
  // Description:
  //      General log indicator from device

  STATUS_SAMPLE_0             = 0xF050,   // 61520
  STATUS_SAMPLE_1             = 0xF051,   // 61521
  STATUS_SAMPLE_2             = 0xF052,   // 61522
  // Description:
  //      General sample triggered by device operator

  STATUS_HEARTBEAT            = 0xF060,   // 61536
  // Description:
  //      General heartbeat/keep-alive event

  STATUS_GPS_FIRST_FIX        = 0xF06A,   // 61546
  // Description:
  //      GPS first fix

  STATUS_POI_0                = 0xF070,   // 61552
  STATUS_POI_1                = 0xF071,   // 61553
  STATUS_POI_2                = 0xF072,   // 61554
  STATUS_POI_3                = 0xF073,   // 61555
  STATUS_POI_4                = 0xF074,   // 61556
  // Description:
  //      General Point-Of-Interest location (event generated by manual user
  //      intervention at the device. ie. By pressing a 'Waymark' button).

  STATUS_DATA_MESSAGE_0       = 0xF080,   // 61568
  STATUS_DATA_MESSAGE_1       = 0xF081,   // 61569
  STATUS_DATA_MESSAGE_2       = 0xF082,   // 61570
  // Description:
  //      General data message from device

  STATUS_DATA_FAILED          = 0xF08F,   // 61583
  // Description:
  //      General data connection/message failed

  STATUS_VOICE                = 0xF090,   // 61584
  // Description:
  //      General voice indicator

  STATUS_VOICE_OUTGOING       = 0xF094,   // 61588
  // Description:
  //      General outgoing voice indicator

  STATUS_VOICE_INCOMING       = 0xF098,   // 61592
  // Description:
  //      General outgoing voice indicator

  STATUS_RFID_TAG_0           = 0xF0A0,   // 61600
  STATUS_RFID_TAG_1           = 0xF0A1,   // 61601
  STATUS_RFID_TAG_2           = 0xF0A2,   // 61602
  // Description:
  //      General RFID events

  STATUS_RFID_TAG_ERROR       = 0xF0AF,   // 61615
  // Description:
  //      General RFID error

  // ----------------------------------------------------------------------------
  // Motion codes: 0xF100 to 0xF1FF
  // (motion related status codes - typically while ignition is on)

  STATUS_MOTION_START         = 0xF111,   // 61713
  // Description:
  //      Device start of motion

  STATUS_MOTION_ENROUTE       = 0xF112,   // 61714
  STATUS_MOTION_EN_ROUTE      = STATUS_MOTION_ENROUTE,
  STATUS_MOTION_IN_MOTION     = STATUS_MOTION_ENROUTE,
  // Description:
  //      Device in-motion interval

  STATUS_MOTION_STOP         = 0xF113,   // 61715
  // Description:
  //      Device stopped motion

  STATUS_MOTION_DORMANT       = 0xF114,   // 61716
  // Description:
  //      Device dormant interval (ie. not moving)

  STATUS_MOTION_STOPPED       = 0xF115,   // 61717
  // Description:
  //      Alternate to Dormant (ie. not moving)
  
  STATUS_MOTION_IDLE         = 0xF116,   // 61718
  // Description:
  //      Device idle interval (ie. not moving, but engine may still be on)
  //      Use by some devices that send a "start-of-idle" event

  STATUS_MOTION_IDLE_END      = 0xF117,   // 61719
  // Description:
  //      Use by some devices that send an "end-of-idle" event

  STATUS_EXCESS_IDLE          = 0xF118,   // 61720
  STATUS_MOTION_EXCESS_IDLE   = STATUS_EXCESS_IDLE,
  // Description:
  //      Device exceeded idle threashold

  STATUS_MOTION_OVER_SPEED_1  = 0xF11A,   // 61722
  STATUS_MOTION_EXCESS_SPEED  = STATUS_MOTION_OVER_SPEED_1,
  // Description:
  //      Device exceeded preset speed limit #1
  // OBSOLETE:
  //      Use STATUS_SPEEDING_BEGIN_1

  STATUS_MOTION_OVER_SPEED_2  = 0xF11B,   // 61723
  // Description:
  //      Device exceeded preset speed limit #2
  // OBSOLETE:
  //      Use STATUS_SPEEDING_BEGIN_2

  STATUS_MOTION_MOVING        = 0xF11C,   // 61724
  // Description:
  //      Device is moving
  // Notes:
  //      - This status code may be used to indicating that the device was moving
  //      at the time the event was generated. It is typically not associated
  //      with the status codes STATUS_MOTION_START, STATUS_MOTION_STOP, and  
  //      STATUS_MOTION_IN_MOTION, and may be used independently of these codes.
  //      - This status code is typically used for devices that need to periodically
  //      report that they are moving, apart from the standard start/stop/in-motion
  //      events.

  STATUS_MOTION_STOP_PENDING  = 0xF11D,   // 61725
  // Description:
  //      Motion changed to stop, waiting for official "Stop" event

  STATUS_MOTION_CHANGE        = 0xF11E,   // 61726
  // Description:
  //      Motion state change (from moving to stopped, or stopped to moving)

  STATUS_MOTION_HEADING       = 0xF11F,   // 61727
  // Description:
  //      Device motion changed direction/heading

  STATUS_MOTION_ACCELEROMETER = 0xF120,   // 61728
  // Description:
  //      Device motion detected due to accelerometer

  STATUS_MOTION_ACCELERATION  = 0xF123,   // 61731
  // Description:
  //      Device motion acceleration change

  STATUS_MOTION_DECELERATION  = 0xF126,   // 61734
  // Description:
  //      Device motion acceleration change

  STATUS_MOTION_SPEED_RECOVER = 0xF12A,   // 61738
  // Description:
  //      Recover from excess speed

  STATUS_ODOM_0               = 0xF130,   // 61744
  STATUS_ODOM_1               = 0xF131,
  STATUS_ODOM_2               = 0xF132,
  STATUS_ODOM_3               = 0xF133,
  STATUS_ODOM_4               = 0xF134,
  STATUS_ODOM_5               = 0xF135,
  STATUS_ODOM_6               = 0xF136,
  STATUS_ODOM_7               = 0xF137,   // 61751
  // Description:
  //      Odometer value
  // Notes:
  //      The odometer limit is provided by property PROP_ODOMETER_#_LIMIT

  STATUS_ODOM_LIMIT_0         = 0xF140,   // 61760
  STATUS_ODOM_LIMIT_1         = 0xF141,
  STATUS_ODOM_LIMIT_2         = 0xF142,
  STATUS_ODOM_LIMIT_3         = 0xF143,
  STATUS_ODOM_LIMIT_4         = 0xF144,
  STATUS_ODOM_LIMIT_5         = 0xF145,
  STATUS_ODOM_LIMIT_6         = 0xF146,
  STATUS_ODOM_LIMIT_7         = 0xF147,   // 61767
  // Description:
  //      Odometer has exceeded a set limit

  STATUS_MAINTENANCE_0        = 0xF150,   // 61776
  STATUS_MAINTENANCE_1        = 0xF151,   // 61777
  STATUS_MAINTENANCE_2        = 0xF152,   // 61778
  STATUS_MAINTENANCE_3        = 0xF153,   // 61779
  STATUS_MAINTENANCE_4        = 0xF154,   // 61780
  // Description:
  //      Maintenance/service interval

  STATUS_SPEEDING_BEGIN       = 0xF160,   // 61792
  STATUS_SPEEDING_BEGIN_1     = 0xF161,   // 61793
  STATUS_SPEEDING_LIMIT_1     = STATUS_SPEEDING_BEGIN_1,
  STATUS_SPEEDING_BEGIN_2     = 0xF162,   // 61794
  STATUS_SPEEDING_LIMIT_2     = STATUS_SPEEDING_BEGIN_2,
  STATUS_SPEEDING_BEGIN_3     = 0xF163,   // 61795
  STATUS_SPEEDING_LIMIT_3     = STATUS_SPEEDING_BEGIN_3,
  STATUS_SPEEDING_BEGIN_4     = 0xF164,   // 61796
  STATUS_SPEEDING_LIMIT_4     = STATUS_SPEEDING_BEGIN_4,
  STATUS_SPEEDING_END_4       = 0xF16B,   // 61803
  STATUS_SPEEDING_END_3       = 0xF16C,   // 61804
  STATUS_SPEEDING_END_2       = 0xF16D,   // 61805
  STATUS_SPEEDING_END_1       = 0xF16E,   // 61806
  STATUS_SPEEDING_END         = 0xF16F,   // 61807
  // Description:
  //      Speeding profile

  STATUS_TRACK_START          = 0xF181,   // 61825
  // Description:
  //      Tracking start

  STATUS_TRACK_LOCATION       = 0xF182,   // 61826
  // Description:
  //      Periodic location event while tracking

  STATUS_TRACK_STOP           = 0xF183,   // 61827
  // Description:
  //      Tracking stop

  STATUS_JOB_START            = 0xF187,   // 61831
  // Description:
  //      Job start

  STATUS_JOB_STOP             = 0xF188,   // 61832
  // Description:
  //      Job stop

  // ----------------------------------------------------------------------------
  // Geofence: 0xF200 to 0xF2FF

  STATUS_GEOFENCE_ARRIVE      = 0xF210,   // 61968
  // Description:
  //      Device arrived at geofence/geozone

  STATUS_CORRIDOR_ARRIVE      = 0xF213,   // 61971
  // Description:
  //      Device entered GeoCorridor

  STATUS_JOB_ARRIVE           = 0xF215,   // 61973
  // Description:
  //      Device arrived at job-site (typically driver entered)

  STATUS_PROXIMITY_ARRIVE     = 0xF219,   // 61977
  // Description:
  //      Device has entered the proximity of another asset

  STATUS_GEOFENCE_DEPART      = 0xF230,   // 62000
  // Description:
  //      Device departed geofence/geozone

  STATUS_CORRIDOR_DEPART      = 0xF233,   // 62003
  // Description:
  //      Device exited GeoCorridor (alternate for STATUS_CORRIDOR_VIOLATION)

  STATUS_JOB_DEPART           = 0xF235,   // 62005
  // Description:
  //      Device departed job-site (typically driver entered)

  STATUS_PROXIMITY_DEPART     = 0xF239,   // 62009
  // Description:
  //      Device has left the proximity of another asset

  // ----------------------

  STATUS_GEOFENCE_VIOLATION   = 0xF250,   // 62032
  // Description:
  //      Geofence violation

  STATUS_CORRIDOR_VIOLATION   = 0xF258,   // 62040
  // Description:
  //      GeoCorridor violation

  STATUS_GEOFENCE_ACTIVE      = 0xF270,   // 62064
  // Description:
  //      Geofence now active

  STATUS_CORRIDOR_ACTIVE      = 0xF278,   // 62072
  // Description:
  //      GeoCorridor now active

  STATUS_GEOFENCE_INACTIVE    = 0xF280,   // 62080
  // Description:
  //      GeoFence now inactive

  STATUS_CORRIDOR_INACTIVE    = 0xF288,   // 62088
  // Description:
  //      GeoCorridor now inactive

  // ----------------------

  STATUS_OFF_ROUTE            = 0xF290,   // 62096
  // Description:
  //      Device is off-route

  STATUS_ON_ROUTE             = 0xF291,   // 62097
  // Description:
  //      Device is on-route

  // ----------------------

  STATUS_GEOBOUNDS_ENTER      = 0xF2A0,   // 62112
  // Description:
  //      Device has entered a geo-boundary (ie state/province)

  STATUS_GEOBOUNDS_EXIT       = 0xF2B0,   // 62128
  // Description:
  //      Device has exited a geo-boundary (ie state/province)

  // ----------------------

  STATUS_PARKED               = 0xF2C0,   // 62144
  // Description:
  //      Device has parked

  STATUS_EXCESS_PARK          = 0xF2C3,   // 62147
  // Description:
  //      Device has exceeded a parked threshold

  STATUS_UNPARKED             = 0xF2C6,   // 62150
  // Description:
  //      Device has unparked

  // ----------------------

  STATUS_ALTITUDE_VIOLATION   = 0xF2D0,   // 62160
  // Description:
  //      Altitude violation

  // ----------------------------------------------------------------------------
  // Digital input/output (state change): 0xF400 to 0xF4FF

  STATUS_INPUT_STATE          = 0xF400,   // 62464
  // Description:
  //      Current input state change

  STATUS_IGNITION_ON          = 0xF401,   // 62465
  // Description:
  //      Ignition turned ON
  // Notes:
  //      - This status code may be used to indicate that the ignition input
  //      turned ON.

  STATUS_INPUT_ON             = 0xF402,   // 62466
  // Description:
  //      Input turned ON

  STATUS_IGNITION_OFF         = 0xF403,   // 62467
  // Description:
  //      Ignition turned OFF
  // Notes:
  //      - This status code may be used to indicate that the ignition input
  //      turned OFF.

  STATUS_INPUT_OFF            = 0xF404,   // 62468
  // Description:
  //      Input turned OFF
  // Notes:
  //      - This status code may be used to indicate that an arbitrary input
  //      'thing' turned OFF, and the 'thing' can be identified by the 'Input ID'.
  //      This 'ID' can also represent the index of a digital input.

  STATUS_INPUT_VIOLATION      = 0xF405,   // 62469
  // Description:
  //      Input violation detected
  // Notes:
  //      - This status code may be used to indicate that an arbitrary input
  //      changed to an unexpected state.

  STATUS_OUTPUT_STATE         = 0xF406,   // 62470
  // Description:
  //      Current output ON state (bitmask)

  STATUS_OUTPUT_ON            = 0xF408,   // 62472
  // Description:
  //      Output turned ON
  // Notes:
  //      - This status code may be used to indicate that an arbitrary output
  //      'thing' turned ON, and the 'thing' can be identified by the 'Output ID'.
  //      This 'ID' can also represent the index of a digital output.

  STATUS_OUTPUT_OFF           = 0xF40A,   // 62474
  // Description:
  //      Output turned OFF
  // Notes:
  //      - This status code may be used to indicate that an arbitrary output
  //      'thing' turned OFF, and the 'thing' can be identified by the 'Output ID'.
  //      This 'ID' can also represent the index of a digital output.

  STATUS_ENGINE_START         = 0xF40C,   // 62476
  // Description:
  //      Engine started
  // Notes:
  //      - This status code may be used to specifically indicate that the engine
  //      has been started.  This may be different from "Ignition On", if the
  //      STATUS_IGNITION_ON also indicates when only the "accessory" loop of
  //      the ignition state is on.

  STATUS_ENGINE_STOP          = 0xF40D,   // 62477
  // Description:
  //      Engine stopped
  // Notes:
  //      - This status code may be used to specifically indicate that the engine
  //      has been stopped.  This may be different from "Ignition Off", if the
  //      STATUS_IGNITION_OFF also indicates when only the "accessory" loop of
  //      the ignition state is off.

  STATUS_INPUT_ON_00          = 0xF420,   // 62496
  STATUS_INPUT_ON_01          = 0xF421,   // 62497
  STATUS_INPUT_ON_02          = 0xF422,   // 62498
  STATUS_INPUT_ON_03          = 0xF423,   // 62499
  STATUS_INPUT_ON_04          = 0xF424,   // 62500
  STATUS_INPUT_ON_05          = 0xF425,   // 62501
  STATUS_INPUT_ON_06          = 0xF426,   // 62502
  STATUS_INPUT_ON_07          = 0xF427,   // 62503
  STATUS_INPUT_ON_08          = 0xF428,   // 62504
  STATUS_INPUT_ON_09          = 0xF429,   // 62505
  STATUS_INPUT_ON_10          = 0xF42A,   // 62406
  STATUS_INPUT_ON_11          = 0xF42B,   // 62407
  STATUS_INPUT_ON_12          = 0xF42C,   // 62408
  STATUS_INPUT_ON_13          = 0xF42D,   // 62409
  STATUS_INPUT_ON_14          = 0xF42E,   // 62510
  STATUS_INPUT_ON_15          = 0xF42F,   // 62511
  STATUS_INPUT_ON_16          = 0xF430,   // 62512
  STATUS_INPUT_ON_17          = 0xF431,   // 62513
  STATUS_INPUT_ON_18          = 0xF432,   // 62514
  STATUS_INPUT_ON_19          = 0xF433,   // 62515
  STATUS_INPUT_ON_20          = 0xF434,   // 62516
  STATUS_INPUT_ON_21          = 0xF435,   // 62517
  STATUS_INPUT_ON_22          = 0xF436,   // 62518
  STATUS_INPUT_ON_23          = 0xF437,   // 62519
  STATUS_INPUT_ON_24          = 0xF438,   // 62520
  STATUS_INPUT_ON_25          = 0xF439,   // 62521
  STATUS_INPUT_ON_26          = 0xF43A,   // 62522
  STATUS_INPUT_ON_27          = 0xF43B,   // 62523
  STATUS_INPUT_ON_28          = 0xF43C,   // 62524
  STATUS_INPUT_ON_29          = 0xF43D,   // 62525
  STATUS_INPUT_ON_30          = 0xF43E,   // 62526
  STATUS_INPUT_ON_31          = 0xF43F,   // 62527
  // Description:
  //      Digital input state changed to ON

  STATUS_INPUT_OFF_00         = 0xF440,   // 62528
  STATUS_INPUT_OFF_01         = 0xF441,   // 62529
  STATUS_INPUT_OFF_02         = 0xF442,   // 62530
  STATUS_INPUT_OFF_03         = 0xF443,   // 62531
  STATUS_INPUT_OFF_04         = 0xF444,   // 62532
  STATUS_INPUT_OFF_05         = 0xF445,   // 62533
  STATUS_INPUT_OFF_06         = 0xF446,   // 62534
  STATUS_INPUT_OFF_07         = 0xF447,   // 62535
  STATUS_INPUT_OFF_08         = 0xF448,   // 62536
  STATUS_INPUT_OFF_09         = 0xF449,   // 62537
  STATUS_INPUT_OFF_10         = 0xF44A,   // 62538
  STATUS_INPUT_OFF_11         = 0xF44B,   // 62539
  STATUS_INPUT_OFF_12         = 0xF44C,   // 62540
  STATUS_INPUT_OFF_13         = 0xF44D,   // 62541
  STATUS_INPUT_OFF_14         = 0xF44E,   // 62542
  STATUS_INPUT_OFF_15         = 0xF44F,   // 62543
  STATUS_INPUT_OFF_16         = 0xF450,   // 62544
  STATUS_INPUT_OFF_17         = 0xF451,   // 62545
  STATUS_INPUT_OFF_18         = 0xF452,   // 62546
  STATUS_INPUT_OFF_19         = 0xF453,   // 62547
  STATUS_INPUT_OFF_20         = 0xF454,   // 62548
  STATUS_INPUT_OFF_21         = 0xF455,   // 62549
  STATUS_INPUT_OFF_22         = 0xF456,   // 62550
  STATUS_INPUT_OFF_23         = 0xF457,   // 62551
  STATUS_INPUT_OFF_24         = 0xF458,   // 62552
  STATUS_INPUT_OFF_25         = 0xF459,   // 62553
  STATUS_INPUT_OFF_26         = 0xF45A,   // 62554
  STATUS_INPUT_OFF_27         = 0xF45B,   // 62555
  STATUS_INPUT_OFF_28         = 0xF45C,   // 62556
  STATUS_INPUT_OFF_29         = 0xF45D,   // 62557
  STATUS_INPUT_OFF_30         = 0xF45E,   // 62558
  STATUS_INPUT_OFF_31         = 0xF45F,   // 62559
  // Description:
  //      Digital input state changed to OFF

  STATUS_OUTPUT_ON_00         = 0xF460,   // 62560
  STATUS_OUTPUT_ON_01         = 0xF461,
  STATUS_OUTPUT_ON_02         = 0xF462,
  STATUS_OUTPUT_ON_03         = 0xF463,
  STATUS_OUTPUT_ON_04         = 0xF464,
  STATUS_OUTPUT_ON_05         = 0xF465,
  STATUS_OUTPUT_ON_06         = 0xF466,
  STATUS_OUTPUT_ON_07         = 0xF467,
  STATUS_OUTPUT_ON_08         = 0xF468,
  STATUS_OUTPUT_ON_09         = 0xF469,   // 62569
  // Description:
  //      Digital output state set to ON
  //      0xFA6A through 0xFA6F reserved

  STATUS_OUTPUT_OFF_00        = 0xF480,   // 62592
  STATUS_OUTPUT_OFF_01        = 0xF481,
  STATUS_OUTPUT_OFF_02        = 0xF482,
  STATUS_OUTPUT_OFF_03        = 0xF483,
  STATUS_OUTPUT_OFF_04        = 0xF484,
  STATUS_OUTPUT_OFF_05        = 0xF485,
  STATUS_OUTPUT_OFF_06        = 0xF486,
  STATUS_OUTPUT_OFF_07        = 0xF487,
  STATUS_OUTPUT_OFF_08        = 0xF488,
  STATUS_OUTPUT_OFF_09        = 0xF489,   // 62601
  // Description:
  //      Digital output state set to OFF
  //      0xFA8A through 0xFA8F reserved

  STATUS_ELAPSED_00           = 0xF4A0,   // 62624
  STATUS_ELAPSED_01           = 0xF4A1,
  STATUS_ELAPSED_02           = 0xF4A2,
  STATUS_ELAPSED_03           = 0xF4A3,
  STATUS_ELAPSED_04           = 0xF4A4,
  STATUS_ELAPSED_05           = 0xF4A5,
  STATUS_ELAPSED_06           = 0xF4A6,
  STATUS_ELAPSED_07           = 0xF4A7,   // 62631
  // Description:
  //      Elapsed time
  //      0xFAA8 through 0xFAAF reserved

  STATUS_ELAPSED_LIMIT_00     = 0xF4B0,   // 62640
  STATUS_ELAPSED_LIMIT_01     = 0xF4B1,   // 62641
  STATUS_ELAPSED_LIMIT_02     = 0xF4B2,   // 62642
  STATUS_ELAPSED_LIMIT_03     = 0xF4B3,   // 62643
  STATUS_ELAPSED_LIMIT_04     = 0xF4B4,   // 62644
  STATUS_ELAPSED_LIMIT_05     = 0xF4B5,   // 62645
  STATUS_ELAPSED_LIMIT_06     = 0xF4B6,   // 62646
  STATUS_ELAPSED_LIMIT_07     = 0xF4B7,   // 62647
  // Description:
  //      Elapsed timer has exceeded a set limit
  //      0xFAB8 through 0xFABF reserved

  STATUS_DOOR_OPEN_0          = 0xF4D0,   // 62672
  STATUS_DOOR_OPEN_1          = 0xF4D1,   // 62673
  STATUS_DOOR_OPEN_2          = 0xF4D2,   // 62674
  STATUS_DOOR_OPEN_3          = 0xF4D3,   // 62675
  STATUS_DOOR_OPEN_4          = 0xF4D4,   // 62676
  STATUS_DOOR_OPEN_5          = 0xF4D5,   // 62677
  // Description:
  //      Door open
  // Notes:
  //      - This status code may be used to specifically indicate that a door
  //      has been opened.  (alternatively a STATUS_INPUT_ON_xx status code
  //      could be used, with the description changed to "door open").

  STATUS_SEATBELT_ON_0        = 0xF4DA,   // 62682
  STATUS_SEATBELT_ON_1        = 0xF4DB,   // 62683
  STATUS_SEATBELT_ON_2        = 0xF4DC,   // 62684
  STATUS_SEATBELT_ON_3        = 0xF4DD,   // 62685
  // Description:
  //      Setbelt on/latched
  // Notes:
  //      - This status code may be used to specifically indicate that a seatbelt
  //      has been latched.  (alternatively a STATUS_INPUT_ON_xx status code
  //      could be used, with the description changed to "setbelt on").

  STATUS_DOOR_CLOSE_0         = 0xF4E0,   // 62688
  STATUS_DOOR_CLOSE_1         = 0xF4E1,   // 62689
  STATUS_DOOR_CLOSE_2         = 0xF4E2,   // 62690
  STATUS_DOOR_CLOSE_3         = 0xF4E3,   // 62691
  STATUS_DOOR_CLOSE_4         = 0xF4E4,   // 62692
  STATUS_DOOR_CLOSE_5         = 0xF4E5,   // 62693
  // Description:
  //      Door closed
  // Notes:
  //      - This status code may be used to specifically indicate that a door
  //      has been closed.  (alternatively a STATUS_INPUT_ON_xx status code
  //      could be used, with the description changed to "door closed").

  STATUS_SEATBELT_OFF_0       = 0xF4EA,   // 62698
  STATUS_SEATBELT_OFF_1       = 0xF4EB,   // 62699
  STATUS_SEATBELT_OFF_2       = 0xF4EC,   // 62700
  STATUS_SEATBELT_OFF_3       = 0xF4ED,   // 62701
  // Description:
  //      Setbelt on/latched
  // Notes:
  //      - This status code may be used to specifically indicate that a seatbelt
  //      has been latched.  (alternatively a STATUS_INPUT_ON_xx status code
  //      could be used, with the description changed to "seatbelt on").

  // ----------------------------------------------------------------------------
  // Analog/etc sensor values (extra data): 0xF600 to 0xF6FF

  STATUS_ANALOG_0             = 0xF600,   // 62976
  STATUS_ANALOG_1             = 0xF601,
  STATUS_ANALOG_2             = 0xF602,
  STATUS_ANALOG_3             = 0xF603,
  STATUS_ANALOG_4             = 0xF604,
  STATUS_ANALOG_5             = 0xF605,
  STATUS_ANALOG_6             = 0xF606,
  STATUS_ANALOG_7             = 0xF607,   // 62983
  // Description:
  //      Analog sensor value
  // Notes:
  //      - Client should include an Analog value in the event packet.

  STATUS_ANALOG_RANGE_0       = 0xF620,   // 63008
  STATUS_ANALOG_RANGE_1       = 0xF621,
  STATUS_ANALOG_RANGE_2       = 0xF622,
  STATUS_ANALOG_RANGE_3       = 0xF623,
  STATUS_ANALOG_RANGE_4       = 0xF624,
  STATUS_ANALOG_RANGE_5       = 0xF625,
  STATUS_ANALOG_RANGE_6       = 0xF626,
  STATUS_ANALOG_RANGE_7       = 0xF627,   // 63015
  // Description: 
  //      Analog sensor value out-of-range violation
  // Notes:
  //      - Client should include an Analog value in the event packet.

  STATUS_HUMIDITY_LOW_0       = 0xF660,   // 63072
  // ...                                              = 0xF66F
  // Description:
  //      Humidity drop below lower range

  STATUS_HUMIDITY_HIGH_0      = 0xF670,   // 63088
  // ...                                              = 0xF67F
  // Description:
  //      Humidity rise above higher range

  STATUS_HUMIDITY_RANGE_0     = 0xF680,   // 63104
  // ...                                              = 0xF68F
  // Description:
  //      Humidity out of range

  STATUS_PRESSURE_LOW_0       = 0xF6A0,   // 63136
  // ...                                              = 0xF6AF
  // Description:
  //      Pressure drop below lower range

  STATUS_PRESSURE_HIGH_0      = 0xF6B0,   // 63152
  // ...                                              = 0xF6BF
  // Description:
  //      Pressure rise above higher range

  STATUS_PRESSURE_RANGE_0     = 0xF6C0,   // 63168
  // ...                                              = 0xF6CF
  // Description:
  //      Pressure out of range

  // ----------------------------------------------------------------------------
  // Temperature sensor values (extra data): 0xF700 to 0xF7FF

  STATUS_TEMPERATURE_0        = 0xF710,   // 63248
  STATUS_TEMPERATURE_1        = 0xF711,
  STATUS_TEMPERATURE_2        = 0xF712,
  STATUS_TEMPERATURE_3        = 0xF713,
  STATUS_TEMPERATURE_4        = 0xF714,
  STATUS_TEMPERATURE_5        = 0xF715,
  STATUS_TEMPERATURE_6        = 0xF716,
  STATUS_TEMPERATURE_7        = 0xF717,   // 63255
  // Description:
  //      Temperature value

  STATUS_TEMPERATURE_RANGE_0  = 0xF730,   // 63280
  STATUS_TEMPERATURE_RANGE_1  = 0xF731,
  STATUS_TEMPERATURE_RANGE_2  = 0xF732,
  STATUS_TEMPERATURE_RANGE_3  = 0xF733,
  STATUS_TEMPERATURE_RANGE_4  = 0xF734,
  STATUS_TEMPERATURE_RANGE_5  = 0xF735,
  STATUS_TEMPERATURE_RANGE_6  = 0xF736,
  STATUS_TEMPERATURE_RANGE_7  = 0xF737,   // 63287
  // Description:
  //      Temperature value out-of-range [low/high/average]

  STATUS_TEMPERATURE_LOW_0    = 0xF740,   // 63296
  // Description:
  //      Temperature #0 drop below lower range

  STATUS_TEMPERATURE_HIGH_0   = 0xF750,   // 63312
  // Description:
  //      Temperature #0 exceeded higher range

  STATUS_TEMPERATURE_OK       = 0xF7F0,   // 63472
  // Description:
  //      All temperature averages [aver/aver/aver/...]

  STATUS_TEMPERATURE          = 0xF7F1,   // 63473
  // Description:
  //      All temperature averages [aver/aver/aver/...]

  // ----------------------------------------------------------------------------
  // Miscellaneous

  STATUS_LOGIN                = 0xF811,   // 63505
  // Description:
  //      Generic 'login'

  STATUS_LOGOUT               = 0xF812,   // 63506
  // Description:
  //      Generic 'logout'

  // --------------------------------

  STATUS_ARMED                = 0xF817,   // 63511
  // Description:
  //      Generic 'armed'

  STATUS_DISARMED             = 0xF818,   // 63512
  // Description:
  //      Generic 'disarmed'

  // --------------------------------

  STATUS_TAG_BATTERY_LOW      = 0xF81D,   // 63517
  // Description:
  //      General RFID tag battery low

  // --------------------------------

  STATUS_ENTITY_STATE         = 0xF820,   // 63520
  // Description:
  //      General Entity state

  STATUS_ENTITY_CONNECT       = 0xF821,   // 63521 [STATUS_CONNECT]
  // Description:
  //      General Entity Connect/Hook/On

  STATUS_ENTITY_DISCONNECT    = 0xF822,   // 63522 [STATUS_DISCONNECT]
  // Description:
  //      General Entity Disconnect/Drop/Off

  STATUS_ENTITY_INVENTORY     = 0xF823,   // 63523
  // Description:
  //      General Entity Inventory

  // --------------------------------

  STATUS_TRAILER_STATE        = 0xF824,   // 63524
  // Description:
  //      Trailer State change

  STATUS_TRAILER_HOOK         = 0xF825,   // 63525
  // Description:
  //      Trailer Hook

  STATUS_TRAILER_UNHOOK       = 0xF826,   // 63526
  // Description:
  //      Trailer Unhook

  STATUS_TRAILER_INVENTORY    = 0xF827,   // 63527
  // Description:
  //      Trailer Inventory

  // --------------------------------

  STATUS_RFID_STATE           = 0xF828,   // 63528
  // Description:
  //      RFID State change

  STATUS_RFID_CONNECT         = 0xF829,   // 63529
  // Description:
  //      RFID Connect/InRange

  STATUS_RFID_DISCONNECT      = 0xF82A,   // 63530
  // Description:
  //      RFID Disconnect/OutOfRange

  STATUS_RFID_INVENTORY       = 0xF82B,   // 63531
  // Description:
  //      RFID Inventory

  // --------------------------------

  STATUS_PERSON_ENTER         = 0xF82C,   // 63532
  // Description:
  //      Passenger/Person Enter/Embark

  STATUS_PERSON_EXIT          = 0xF82D,   // 63533
  // Description:
  //      Passenger/Person Exit/Disembark

  STATUS_PERSON_INVENTORY     = 0xF82E,   // 63534
  // Description:
  //      Passenger/Person Inventory

  // STATUS_PERSON_STATE         = 0xF82F,   // 63535
  // Description:
  //      Passenger/Person State change
  STATUS_DRIVER_TAILGATING       = 0xF82F,   // 63535
  // Description:
  //      Driver Tailgating (updated 7/8/2025 from person state to tailgating)

  // --------------------------------

  STATUS_ACK                  = 0xF831,   // 63537
  // Description:
  //      Acknowledge

  STATUS_NAK                  = 0xF832,   // 63538
  // Description:
  //      Negative Acknowledge

  // --------------------------------

  STATUS_COMMAND_ACK          = 0xF833,   // 63539
  // Description:
  //      General Command Acknowledge

  STATUS_COMMAND_NAK          = 0xF834,   // 63540
  // Description:
  //      General Command Negative Acknowledge

  // --------------------------------

  STATUS_DUTY_ON              = 0xF837,   // 63543
  // Description:
  //      Duty condition activated

  STATUS_DUTY_OFF             = 0xF838,   // 63544
  // Description:
  //      Duty condition deactivated

  // --------------------------------

  STATUS_PANIC_ON             = 0xF841,   // 63553
  // Description:
  //      Panic/SOS condition activated

  STATUS_PANIC_OFF            = 0xF842,   // 63554
  // Description:
  //      Panic/SOS condition deactivated

  // --------------------------------

  STATUS_PTT_ON               = 0xF843,   // 63555
  // Description:
  //      Push-To-Talk ON

  STATUS_PTT_OFF              = 0xF844,   // 63556
  // Description:
  //      Push-To-Talk OFF

  // --------------------------------

  STATUS_ALARM_ON             = 0xF847,   // 63559
  // Description:
  //      General Alarm condition activated

  STATUS_ALARM_OFF            = 0xF848,   // 63560
  // Description:
  //      General Alarm condition deactivated

  // --------------------------------

  STATUS_SENSOR_ON            = 0xF84B,   // 63563
  // Description:
  //      sensor activated

  STATUS_SENSOR_OFF           = 0xF84C,   // 63564
  // Description:
  //      sensor deactivated

  // --------------------------------

  STATUS_CUSTOM_ON            = 0xF84D,   // 63565
  // Description:
  //      sensor activated

  STATUS_CUSTOM_OFF           = 0xF84E,   // 63566
  // Description:
  //      sensor deactivated

  // --------------------------------

  STATUS_ASSIST_ON            = 0xF851,   // 63569
  // Description:
  //      Assist condition activated

  STATUS_ASSIST_OFF           = 0xF852,   // 63570
  // Description:
  //      Assist condition deactivated

  // --------------------------------

  STATUS_MANDOWN_ON           = 0xF855,   // 63573
  // Description:
  //      man-down activated

  STATUS_MANDOWN_OFF          = 0xF856,   // 63574
  // Description:
  //      man-down deactivated

  // --------------------------------

  STATUS_MEDICAL_ON           = 0xF861,   // 63585
  // Description:
  //      Medical Call condition activated

  STATUS_MEDICAL_OFF          = 0xF862,   // 63586
  // Description:
  //      Medical Call condition deactivated

  // --------------------------------

  STATUS_DRIVER_CHANGE        = 0xF865,   // 63589
  // Description:
  //      new driver

  STATUS_DRIVER_AUTHORIZED    = 0xF866,   // 63590
  // Description:
  //      driver authorized

  STATUS_NO_BADGE_PRESENTED   = 0xF86F,   // 63599
  // Description:
  //      driver no badge presented

  STATUS_DRIVER_CLASS_MISMATCH  = 0xF869,   // 63593
  // Description:
  //      driver no badge presented

  STATUS_DRIVER_UNAUTHORIZED  = 0xF867,   // 63591
  // Description:
  //      driver unauthorized

  STATUS_DRIVER_FATIGUE       = 0xF868,   // 63592
  // Description:
  //      driver fatigued

  STATUS_DRIVER_SLEEP         = 0xF869,   // 63593
  // Description:
  //      driver sleep

  STATUS_DRIVER_WAKE          = 0xF86A,   // 63594
  // Description:
  //      driver wake

  STATUS_DRIVER_MESSAGE       = 0xF86D,   // 63597
  // Description:
  //      driver message

  STATUS_DRIVER_SMOKING       = 0xF863,   // 63587
  STATUS_DRIVER_CELLPHONE     = 0xF864,   // 63588
  STATUS_DRIVER_DISTRACTED    = 0xF86B,   // 63595
  STATUS_DRIVER_EAT_DRINK     = 0xF86C,   // 63596
  STATUS_DRIVER_SEATBELT_OFF  = 0xF4EA,   // 62698

  STATUS_CAMERA_STANDBY_0  	= 0xF4FA,   // 62714
  STATUS_GSENSOR_NORMAL  		= 0xF947,   // 63815
  STATUS_GSENSOR_HIGH  		= 0xF946,   // 63814
  STATUS_CAMERA_ON_0  		= 0xF4F0,   // 62704
  STATUS_CAMERA_OFF_0  		= 0xF4F5,   // 62709
  STATUS_INVALID_LOGIN  		= 0xF813,   // 63507
  STATUS_REGISTERED	  		= 0xF00F,   // 61455
  STATUS_CAMERA_OBSTRUCTED	= 0xF887,   // 63623





  // --------------------------------

  STATUS_TOWING_START         = 0xF871,   // 63601
  // Description:
  //      Vehicle started to be towed

  STATUS_TOWING_STOP          = 0xF872,   // 63602
  // Description:
  //      Vehicle stopped being towed

  STATUS_TOWING_ENROUTE       = 0xF873,   // 63603
  // Description:
  //      Vehicle enroute while being towed

  // --------------------------------

  STATUS_INTRUSION_ON         = 0xF881,   // 63617
  // Description:
  //      Intrusion detected

  STATUS_INTRUSION_OFF        = 0xF882,   // 63618
  // Description:
  //      Intrusion stopped

  // --------------------------------

  STATUS_TAMPER_ON            = 0xF885,   // 63621
  // Description:
  //      Tamper detected

  STATUS_TAMPER_OFF           = 0xF886,   // 63622
  // Description:
  //      Tamper stopped

  // --------------------------------

  STATUS_BREACH_ON            = 0xF889,   // 63625
  // Description:
  //      Breach detected

  STATUS_BREACH_OFF           = 0xF88A,   // 63626
  // Description:
  //      Breach stopped

  // --------------------------------

  STATUS_CLASP_ON             = 0xF88B,   // 63627
  // Description:
  //      Clasp/Strap/Connector on

  STATUS_CLASP_OFF            = 0xF88C,   // 63628
  // Description:
  //      Clasp/Strap/Connector off

  // --------------------------------

  STATUS_SAFETY_ON            = 0xF88D,   // 63629
  // Description:
  //      Safety on

  STATUS_SAFETY_OFF           = 0xF88E,   // 63630
  // Description:
  //      Safety off

  // --------------------------------

  STATUS_VIBRATION_TRIGGER    = 0xF890,   // 63632
  // Description:
  //      Vibration triggered event

  STATUS_VIBRATION_ON         = 0xF891,   // 63633
  // Description:
  //      Vibration on

  STATUS_VIBRATION_OFF        = 0xF892,   // 63634
  // Description:
  //      Vibration off

  // --------------------------------

  STATUS_DOOR_LOCK            = 0xF895,   // 63637
  // Description:
  //      Door lock

  STATUS_DOOR_UNLOCK          = 0xF896,   // 63638
  // Description:
  //      Door unlock

  // --------------------------------

  STATUS_HANDBRAKE_ON         = 0xF897,   // 63639
  // Description:
  //      Hand/Emergency brake on

  STATUS_HANDBRAKE_OFF        = 0xF898,   // 63640
  // Description:
  //      Hand/Emergency brake off

  // --------------------------------

  STATUS_PTO_ON               = 0xF899,   // 63641
  // Description:
  //      PTO on

  STATUS_PTO_OFF              = 0xF89A,   // 63642
  // Description:
  //      PTO off

  // --------------------------------

  STATUS_ONLINE               = 0xF89D,   // 63645
  // Description:
  //      Online

  STATUS_OFFLINE              = 0xF89E,   // 63646
  // Description:
  //      Offline

  // --------------------------------

  STATUS_LIGHTING_CHANGED     = 0xF8A0,   // 63648
  // Description:
  //      Light detection changed

  STATUS_LIGHTING_BRIGHTER    = 0xF8A3,   // 63651
  // Description:
  //      Dark to Light

  STATUS_LIGHTING_DARKER      = 0xF8A6,   // 63654
  // Description:
  //      Dark to Light

  // --------------------------------

  STATUS_HEADLIGHTS_ON        = 0xF8A9,   // 63657
  // Description:
  //      Headlights on

  STATUS_HEADLIGHTS_OFF       = 0xF8AA,   // 63658
  // Description:
  //      Headlights off

  // --------------------------------

  STATUS_HAZARDLIGHTS_ON      = 0xF8AB,   // 63659
  // Description:
  //      Headlights on

  STATUS_HAZARDLIGHTS_OFF     = 0xF8AC,   // 63660
  // Description:
  //      Headlights off

  // ----------------------------------------------------------------------------
  // Carjacking status: 0xF8B0 to 0xF8BF

  STATUS_CARJACK_DISABLED     = 0xF8B0,   // 63664 [01]
  // Description:
  //      Cajack detection disabled

  STATUS_CARJACK_ENABLED      = 0xF8B1,   // 63665
  // Description:
  //      Cajack detection enabled

  STATUS_CARJACK_STANDBY      = 0xF8B2,   // 63666
  // Description:
  //      Cajack detection stand-by

  STATUS_CARJACK_ARMED        = 0xF8B3,   // 63667 [02]
  // Description:
  //      Cajack detection armed - possible carjack in progress

  STATUS_CARJACK_TRIGGERED    = 0xF8B5,   // 63669 [03]
  // Description:
  //      Cajack triggered - carjack in progress

  STATUS_CARJACK_CANCELLED    = 0xF8B7,   // 63671 [10]
  //STATUS_CARJACK_CANCELLED    = 0xF8B8,   // [20]
  //STATUS_CARJACK_CANCELLED    = 0xF8BA,   // [30]
  //STATUS_CARJACK_CANCELLED    = 0xF8BC,   // [40]
  // Description:
  //      Cajack action cancelled

  // ----------------------------------------------------------------------------

  STATUS_VEHICLE_DISABLED     = 0xF8C0,   // 63680
  // Description:
  //      Vehicle disabled

  STATUS_VEHICLE_ENABLED      = 0xF8C1,   // 63681
  // Description:
  //      Vehicle enabled

  // --------------------------------

  STATUS_SOUND_TRIGGER        = 0xF8C4,   // 63684
  // Description:
  //      Sound triggered event

  STATUS_SOUND_ON             = 0xF8C6,   // 63686
  // Description:
  //      Sound on

  STATUS_SOUND_OFF            = 0xF8C8,   // 63688
  // Description:
  //      Sound off

  // ----------------------------------------------------------------------------
  // Entity status: 0xF8E0 to 0xF8FF

  // ----------------------------------------------------------------------------
  // OBC/J1708/CANBUS status: 0xF900 to 0xF9FF

  STATUS_OBD_INFO_0           = 0xF900,   // 
  STATUS_OBD_INFO_1           = 0xF901,
  STATUS_OBD_INFO_2           = 0xF902,
  STATUS_OBD_INFO_3           = 0xF903,
  STATUS_OBD_INFO_4           = 0xF904,   // 
  STATUS_OBD_INFO_5           = 0xF905,   // 
  STATUS_OBD_INFO_6           = 0xF906,   // 
  STATUS_OBD_INFO_7           = 0xF907,   // 
  // Description:
  //      OBC/J1708 information packet

  STATUS_OBD_CONNECT          = 0xF90F,   // 63759
  // Description:
  //      OBD connected to vehicle

  STATUS_OBD_DISCONNECT       = 0xF910,   // 63760
  // Description:
  //      OBD disconnected from vehicle

  STATUS_OBD_FAULT            = 0xF911,   // 63761
  // Description:
  //      OBC/J1708 fault code occurred. (should be combined with DTC codes)

  STATUS_CHECK_ENGINE         = 0xF915,   // 63765
  STATUS_CHECK_ENGINE_ON      = STATUS_CHECK_ENGINE,
  // Description:
  //      Malfunction Indicator Lamp (MIL) turned ON

  STATUS_CHECK_ENGINE_OFF     = 0xF916,   // 63766
  // Description:
  //      Malfunction Indicator Lamp (MIL) turned OFF

  STATUS_ENGINE_NO_WARM_UP    = 0xF91A,   // 63770
  // Description:
  //      Vehicle ID

  STATUS_OBD_VIN              = 0xF91F,   // 63775
  // Description:
  //      Vehicle ID

  STATUS_OBD_RANGE            = 0xF920,   // 63776
  // Description:
  //      Generic OBC/J1708 value out-of-range

  STATUS_OBD_RPM_RANGE        = 0xF922,   // 63778
  // Description:
  //      OBC/J1708 RPM out-of-range

  STATUS_OBD_RPM_OK           = 0xF923,   // 63779
  // Description:
  //      OBC/J1708 RPM back in range

  STATUS_OBD_FUEL_RANGE       = 0xF924,   // 63780
  // Description:
  //      OBC/J1708 Fuel level out-of-range (ie. to low)
  // Notes:
  //      - This code can also be used to indicate possible fuel theft.

  STATUS_OBD_OIL_RANGE        = 0xF926,   // 63782
  // Description:
  //      OBC/J1708 Oil level out-of-range (ie. to low)

  STATUS_OBD_TEMP_RANGE       = 0xF928,   // 63784
  // Description:
  //      OBC/J1708 Temperature (engine/coolant) out-of-range

  STATUS_OBD_LOAD_RANGE       = 0xF92A,   // 63786
  // Description:
  //      OBC/J1708 Engine-Load out-of-range

  STATUS_OBD_COOLANT_RANGE    = 0xF92C,   // 63788
  // Description:
  //      OBC/J1708 Engine coolant level/temp out-of-range

  STATUS_OBD_COOLANT_OK       = 0xF92D,   // 63789
  // Description:
  //      OBC/J1708 Engine coolant level/temp normal/restored

  STATUS_HARSH_BEHAVIOR       = 0xF92E,   // 63790
  // Description:
  //      General Harsh behavior detected

  STATUS_EXCESS_BRAKING       = 0xF930,   // 63792
  STATUS_EXCESS_BRAKING_2     = 0xF931,   // 63793
  STATUS_EXCESS_BRAKING_3     = 0xF932,   // 63794
  STATUS_EXCESS_BRAKING_4     = 0xF933,   // 63795
  // Description:
  //      Excessive/Harsh deceleration detected

  STATUS_EXCESS_CORNERING     = 0xF937,   // 63799
  STATUS_EXCESS_CORNERING_2   = 0xF938,   // 63800
  STATUS_EXCESS_CORNERING_3   = 0xF939,   // 63801
  STATUS_EXCESS_CORNERING_4   = 0xF93A,   // 63802
  // Description:
  //      Excessive lateral acceleration detected
  //      Also called "hard turning", "veer alarm", "lateral acceleration"

  STATUS_IMPACT               = 0xF941,   // 63809
  STATUS_IMPACT_DATA_1        = 0xF942,   // 63810
  STATUS_IMPACT_DATA_2        = 0xF943,   // 63811
  STATUS_IMPACT_DATA_3        = 0xF944,   // 63812
  // Description:
  //      Excessive acceleration/deceleration detected (collision)

  STATUS_FREEFALL             = 0xF945,   // 63813
  // Description:
  //      Freefall detected

  STATUS_TILT                 = 0xF949,   // 63817
  // Description:
  //      Above/Below inclinometer
  //      Also "roll over", "off camber"

  STATUS_FUEL_REFILL          = 0xF951,   // 63825
  // Description:
  //      Fuel refill detected

  STATUS_FUEL_THEFT           = 0xF952,   // 63826
  // Description:
  //      Fuel theft detected

  STATUS_LOW_FUEL             = 0xF954,   // 63828
  // Description:
  //      Low fuel alert

  STATUS_FUEL_ON              = 0xF958,   // 63832
  // Description:
  //      fuel on/restored

  STATUS_FUEL_OFF             = 0xF959,   // 63833
  // Description:
  //      fuel off/cut

  STATUS_FUEL_DIRTY           = 0xF95A,   // 63834
  // Description:
  //      Fuel contaminated/dirty

  STATUS_FUEL_SENSOR          = 0xF95E,   // 63838
  // Description:
  //      Fuel sensor failed/bad

  STATUS_FUEL_SENSOR_OK       = 0xF95F,   // 63839
  // Description:
  //      Fuel sensor ok

  STATUS_EXCESS_ACCEL         = 0xF960,   // 63840
  STATUS_EXCESS_ACCEL_2       = 0xF961,   // 63841
  STATUS_EXCESS_ACCEL_3       = 0xF962,   // 63842
  // Description:
  //      Excessive acceleration detected

  STATUS_TACHOGRAPH_1         = 0xF9A0,   // 63904
  STATUS_TACHOGRAPH_2         = 0xF9A1,   // 63905
  STATUS_TACHOGRAPH_3         = 0xF9A2,   // 63906
  // Description:
  //      Excessive acceleration detected

  STATUS_TRANSMISSION_GEAR    = 0xF9B0,   // 63920
  // Description:
  //      Transmission gear changed

  STATUS_TRANSMISSION_REVERSE = 0xF9B1,   // 63921
  // Description:
  //      Transmission gear in reverse

  // Camera Events

  // ----------------------------------------------------------------------------
  // Device custom status

  STATUS_DAY_SUMMARY          = 0xFA00,   // 64000
  // Description:
  //      End-Of-Day Summary

  STATUS_TRIP_SUMMARY         = 0xFA40,   // 64064
  // Description:
  //      End-Of-Day Summary

  // ----------------------------------------------------------------------------
  // Tire Pressure/Temperature

  STATUS_TIRE_TEMP_RANGE      = 0xFBA0,   // 64416
  // Description:
  //      Tire Temperature out-of-range

  STATUS_TIRE_PRESSURE_RANGE  = 0xFBB0,   // 64432
  // Description:
  //      Tire Pressure out-of-range

  STATUS_TIRE_PRESSURE_LOW    = 0xFBC0,   // 64448
  // Description:
  //      Tire Pressure low

  STATUS_TIRE_BATTERY_LOW     = 0xFBD0,   // 64464
  // Description:
  //      Tire sensor battery low

  // ----------------------------------------------------------------------------
  // Internal device status

  STATUS_IP_ADDRESS           = 0xFD01,   // 64769
  // Description:
  //      IP Address changed

  STATUS_SIM_CARD             = 0xFD03,   // 64771
  // Description:
  //      SIM Card changed

  STATUS_LOW_VOLTAGE          = 0xFD06,   // 64774
  // Description:
  //      Generic Low voltage

  STATUS_HIGH_VOLTAGE         = 0xFD07,   // 64775
  // Description:
  //      Generic Low voltage

  STATUS_VOLTAGE_ALERT        = 0xFD08,   // 64776
  // Description:
  //      Generic Low voltage

  STATUS_BATTERY_VOLTS        = 0xFD0A,   // 64778
  // Description:
  //      Battery voltage

  STATUS_BACKUP_VOLTS         = 0xFD0C,   // 64780
  // Description:
  //      Backup Battery voltage

  STATUS_BATT_CHARGE_ON       = 0xFD0E,   // 64782
  // Description:
  //      Battery charging on

  STATUS_BATT_CHARGE_OFF      = 0xFD0F,   // 64783
  // Description:
  //      Battery charging off

  STATUS_LOW_BATTERY          = 0xFD10,   // 64784  [BATTERY_LOW]
  // Description:
  //      Low battery indicator

  STATUS_BATTERY_LEVEL        = 0xFD11,   // 64785
  // Description:
  //      Battery indicator

  STATUS_BATTERY_RESTORED     = 0xFD12,   // 64786
  // Description:
  //      Battery level restored

  STATUS_POWER_FAILURE        = 0xFD13,   // 64787
  // Description:
  //      Power failure indicator (or running on internal battery)

  STATUS_POWER_ALARM          = 0xFD14,   // 64788
  // Description:
  //      Power alarm condition

  STATUS_POWER_RESTORED       = 0xFD15,   // 64789
  // Description:
  //      Power restored (after previous failure)

  STATUS_POWER_OFF            = 0xFD17,   // 64791
  // Description:
  //      Power failure indicator (or running on internal battery)

  STATUS_POWER_ON             = 0xFD19,   // 64793
  // Description:
  //      Power restored (after previous failure)

  STATUS_LOW_POWER_MODE       = 0xFD1B,   // 64795
  // Description:
  //      Low Power Mode

  STATUS_FULL_POWER_MODE      = 0xFD1C,   // 64796
  // Description:
  //      Normal Power Mode

  STATUS_GPS_OFF              = 0xFD1E,   // 64798
  // Description:
  //      GPS was turned off

  STATUS_GPS_ON               = 0xFD1F,   // 64799
  // Description:
  //      GPS was turned on

  STATUS_GPS_EXPIRED          = 0xFD21,   // 64801
  // Description:
  //      GPS fix expiration detected

  STATUS_GPS_FAILURE          = 0xFD22,   // 64802
  // Description:
  //      GPS receiver failure detected

  STATUS_GPS_ANTENNA_OPEN     = 0xFD23,   // 64803
  // Description:
  //      GPS antenna open detected

  STATUS_GPS_ANTENNA_SHORT    = 0xFD24,   // 64804
  // Description:
  //      GPS antenna open detected

  STATUS_GPS_JAMMING          = 0xFD25,   // 64805
  // Description:
  //      GPS receiver jamming detected

  STATUS_GPS_RESTORED         = 0xFD26,   // 64806
  // Description:
  //      GPS receiver restore detected

  STATUS_GPS_LOST             = 0xFD27,   // 64807
  // Description:
  //      GPS receiver unable to obtain fix

  STATUS_CALIBRATION_START    = 0xFD2A,   // 64810
  // Description:
  //      General Calibration start message

  STATUS_CALIBRATION_END      = 0xFD2B,   // 64811
  // Description:
  //      General Calibration complete message

  STATUS_CALIBRATION_FAILED   = 0xFD2C,   // 64812
  // Description:
  //      General Calibration failed message

  STATUS_DIAGNOSTIC           = 0xFD30,   // 64816
  // Description:
  //      General Diagnostic message

  STATUS_CONNECTION_LOST      = 0xFD31,   // 64817
  STATUS_CONNECTION_FAILURE   = STATUS_CONNECTION_LOST,
  // Description:
  //      Modem/GPRS/CDMA Connection failure detected

  STATUS_CONNECTION_RESTORED  = 0xFD32,   // 64818
  // Description:
  //      Modem/GPRS/CDMA Connection restore detected

  STATUS_MODEM_FAILURE        = 0xFD33,   // 64819
  // Description:
  //      Modem failure detected

  STATUS_INTERNAL_FAILURE     = 0xFD35,   // 64821
  // Description:
  //      Internal failure detected

  STATUS_MODEM_ON             = 0xFD37,   // 64823
  // Description:
  //      Modem was turned on

  STATUS_MODEM_OFF            = 0xFD38,   // 64824
  // Description:
  //      Modem was turned off

  STATUS_MODEM_JAMMING        = 0xFD39,   // 64825
  // Description:
  //      Modem detected jamming

  STATUS_MODEM_RESTORED       = 0xFD3A,   // 64826
  // Description:
  //      Modem restored

  STATUS_MODEM_REBOOT         = 0xFD3B,   // 64827
  // Description:
  //      Modem reboot

  STATUS_CONFIG_STATUS        = 0xFD40,   // 64832
  // Description:
  //      Firmware/Configuration status

  STATUS_CONFIG_RESET         = 0xFD41,   // 64833
  // Description:
  //      Firmware/Configuration reset

  STATUS_CONFIG_START         = 0xFD42,   // 64834
  // Description:
  //      Firmware/Configuration update starting

  STATUS_CONFIG_COMPLETE      = 0xFD43,   // 64835
  // Description:
  //      Firmware/Configuration (OTA/FOTA) complete/finished 

  STATUS_CONFIG_FAILED        = 0xFD44,   // 64836
  // Description:
  //      Configuration failed

  STATUS_SHUTDOWN             = 0xFD45,   // 64837
  // Description:
  //      device shutdown

  STATUS_SHUTDOWN_CANCELLED   = 0xFD47,   // 64839
  // Description:
  //      device shutdown

  STATUS_SUSPEND              = 0xFD48,   // 64840
  // Description:
  //      device sleep/suspend

  STATUS_RESUME               = 0xFD4A,   // 64842
  // Description:
  //      device resume

  STATUS_ROAMING_ON           = 0xFD51,   // 64849
  // Description:
  //      modem roaming ON

  STATUS_ROAMING_OFF          = 0xFD52,   // 64850
  // Description:
  //      modem roaming OFF

  STATUS_ROAMING_UNKNOWN      = 0xFD53,   // 64851
  // Description:
  //      modem roaming unknown

  // ----------------------------------------------------------------------------
  // General image attachments

  STATUS_IMAGE_0              = 0xFD60,   // 64864
  STATUS_IMAGE_1              = 0xFD61,   // 64865
  STATUS_IMAGE_2              = 0xFD62,   // 64866
  STATUS_IMAGE_3              = 0xFD63,   // 64867
  STATUS_IMAGE_4              = 0xFD64,   // 64868
  // Description:
  //      image attachment

  STATUS_IMAGE_LOC_0          = 0xFD70,   // 64880
  STATUS_IMAGE_LOC_1          = 0xFD71,   // 64881
  STATUS_IMAGE_LOC_2          = 0xFD72,   // 64882
  STATUS_IMAGE_LOC_3          = 0xFD73,   // 64883
  STATUS_IMAGE_LOC_4          = 0xFD74,   // 64884
  // Description:
  //      image location

  STATUS_IMAGE_ERROR_0        = 0xFD80,   // 64896
  STATUS_IMAGE_ERROR_1        = 0xFD81,   // 64897
  STATUS_IMAGE_ERROR_2        = 0xFD82,   // 64898
  STATUS_IMAGE_ERROR_3        = 0xFD83,   // 64899
  STATUS_IMAGE_ERROR_4        = 0xFD84,   // 64900
  // Description:
  //      image location

  // ----------------------------------------------------------------------------
  // General Rule trigger status

  STATUS_RULE_TRIGGER_0       = 0xFF00,   // 65280
  STATUS_RULE_TRIGGER_1       = 0xFF01,   // 65281
  STATUS_RULE_TRIGGER_2       = 0xFF02,   // 65282
  STATUS_RULE_TRIGGER_3       = 0xFF03,   // 65283
  STATUS_RULE_TRIGGER_4       = 0xFF04,   // 65284
  STATUS_RULE_TRIGGER_5       = 0xFF05,   // 65285
  STATUS_RULE_TRIGGER_6       = 0xFF06,   // 65286
  STATUS_RULE_TRIGGER_7       = 0xFF07,   // 65287

  // ----------------------------------------------------------------------------    
  // --------------------------------

  STATUS_PLOW_INIT            = 0xF874,   // 63604
  // Description:
  //      Plowing route started

  STATUS_PLOW_START           = 0xF875,   // 63605
  // Description:
  //      Plowing route started

  STATUS_PLOW_STOP            = 0xF876,   // 63606
  // Description:
  //      Plowing route stopped

  STATUS_PLOW_ABORT           = 0xF877,   // 63607
  // Description:
  //      Plowing route abort

  STATUS_PLOW_WORK            = 0xF878,   // 63608
  // Description:
  //      Plowing route working

  STATUS_PLOW_STANDBY         = 0xF87E,   // 63614
  // Description:
  //      Plowing stand-by

  STATUS_PLOW_ERROR           = 0xF87F,   // 63615
  // Description:
  //      Plowing error



  // Description:
  //      General Rule trigger status

  // ----------------------------------------------------------------------------
  // End of standard status codes
  STATUS_FFFF                 = 0xFFFF,   //

  'EVENT_VALID_GPSEVENT_VALID_GPS+MOVING_ELAPSED' = 0,
  'EVENT_INVALID_GPSEVENT_INVALID_GPS+STOPPED_ELASPED'= 0,
   EVENT_SPEEDING_1 = 0,
   STATUS_MOTION_OVER_SPEED = 0,
   EVENT_SPEED_OVER_75 = 0,
   STATUS_DRIVER_EATING = 0,
   STATUS_STANDBY_ENTER =0 ,
   STATUS_STANDBY_EXIT =0,
   VALID_BADGE = 63598,
   NO_BADGE_PRESENT=0,
   BUZZER_ON=0,
   OBSTRUCTION=0,



  // ----------------------------------------------------------------------------
  // ----------------------------------------------------------------------------
  // ----------------------------------------------------------------------------

  // 7/8/2025 New Events added during camera admin development
  STATUS_FRONT_COLLISION_WARN = 0xF9C0, // 63936
  // Description:
  //      Front collision warning

  STATUS_PEDESTRIAN_COLLISION = 0xF9C7, // 63943
  // Description:
  //      Pedestrian collision warning

  STATUS_LANE_DEPARTURE       = 0xF971, // 63857
  // Description:
  //      Lane departure

  STATUS_STOP_AND_GO          = 0xF976, // 63862
  // Description:
  //      Stop and go

  STATUS_SPEED_CAMERA_NOTIF   = 0xF176, // 61814
  // Description:
  //      Speed camera notification

  STATUS_ROLLING_STOP         = 0xF972, // 63858
  // Description:
  //      Rolling stop

  STATUS_RAILROAD_CROSSING    = 0xF974, // 63860
  // Description:
  //      Railroad crossing notification

  STATUS_SCHOOL_ZONE_SPEED    = 0xF175, // 61813
  // Description:
  //      School zone speed violation

}